import React from 'react';
import Image from 'next/image';

const SupplyChainSoftwareImage = () => {
    return (
        <div>
            <div className="container-fluid">
                <div className="row grid lg:grid-cols-12">
                    <div className="lg:col-span-12 text-center">
                        <Image
                            src="/img/supply-chain-management.svg"
                            className="img-fluid w-full"
                            alt="supply-chain-management"
                            title="supply-chain-management"
                            height={187}
                            width={1380}
                            loading="lazy"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};
export default SupplyChainSoftwareImage;
